'use strict';
var m = Object.defineProperty;
var C = Object.getOwnPropertyDescriptor;
var w = Object.getOwnPropertyNames;
var M = Object.prototype.hasOwnProperty;
var I = (s, i) => {
    for (var t in i) m(s, t, { get: i[t], enumerable: !0 });
  },
  P = (s, i, t, e) => {
    if ((i && typeof i == 'object') || typeof i == 'function')
      for (let n of w(i)) !M.call(s, n) && n !== t && m(s, n, { get: () => i[n], enumerable: !(e = C(i, n)) || e.enumerable });
    return s;
  };
var k = (s) => P(m({}, '__esModule', { value: !0 }), s);
var G = {};
I(G, { WebHaptics: () => y, defaultPatterns: () => f, version: () => g });
var g = '0.0.6';
var f = {
  success: {
    pattern: [
      { duration: 30, intensity: 0.5 },
      { delay: 60, duration: 40, intensity: 1 },
    ],
  },
  warning: {
    pattern: [
      { duration: 40, intensity: 0.8 },
      { delay: 100, duration: 40, intensity: 0.6 },
    ],
  },
  error: {
    pattern: [
      { duration: 40, intensity: 0.9 },
      { delay: 40, duration: 40, intensity: 0.9 },
      { delay: 40, duration: 40, intensity: 0.9 },
    ],
  },
  light: { pattern: [{ duration: 15, intensity: 0.4 }] },
  medium: { pattern: [{ duration: 25, intensity: 0.7 }] },
  heavy: { pattern: [{ duration: 35, intensity: 1 }] },
  soft: { pattern: [{ duration: 40, intensity: 0.5 }] },
  rigid: { pattern: [{ duration: 10, intensity: 1 }] },
  selection: { pattern: [{ duration: 8, intensity: 0.3 }] },
  nudge: {
    pattern: [
      { duration: 80, intensity: 0.8 },
      { delay: 80, duration: 50, intensity: 0.3 },
    ],
  },
  buzz: { pattern: [{ duration: 1e3, intensity: 1 }] },
};
var L = 16,
  A = 184,
  x = 1e3,
  b = 20;
function S(s) {
  if (typeof s == 'number') return { vibrations: [{ duration: s }] };
  if (typeof s == 'string') {
    let i = f[s];
    return i ? { vibrations: i.pattern.map((t) => ({ ...t })) } : (console.warn(`[web-haptics] Unknown preset: "${s}"`), null);
  }
  if (Array.isArray(s)) {
    if (s.length === 0) return { vibrations: [] };
    if (typeof s[0] == 'number') {
      let i = s,
        t = [];
      for (let e = 0; e < i.length; e += 2) {
        let n = e > 0 ? i[e - 1] : 0;
        t.push({ ...(n > 0 && { delay: n }), duration: i[e] });
      }
      return { vibrations: t };
    }
    return { vibrations: s.map((i) => ({ ...i })) };
  }
  return { vibrations: s.pattern.map((i) => ({ ...i })) };
}
function O(s, i) {
  if (i >= 1) return [s];
  if (i <= 0) return [];
  let t = Math.max(1, Math.round(b * i)),
    e = b - t,
    n = [],
    r = s;
  for (; r >= b; ) (n.push(t), n.push(e), (r -= b));
  if (r > 0) {
    let a = Math.max(1, Math.round(r * i));
    n.push(a);
    let o = r - a;
    o > 0 && n.push(o);
  }
  return n;
}
function H(s, i) {
  let t = [];
  for (let e = 0; e < s.length; e++) {
    let n = s[e],
      r = Math.max(0, Math.min(1, n.intensity ?? i)),
      a = n.delay ?? 0;
    a > 0 && (t.length > 0 && t.length % 2 === 0 ? (t[t.length - 1] += a) : (t.length === 0 && t.push(0), t.push(a)));
    let o = O(n.duration, r);
    if (o.length === 0) {
      t.length > 0 && t.length % 2 === 0 ? (t[t.length - 1] += n.duration) : n.duration > 0 && (t.push(0), t.push(n.duration));
      continue;
    }
    for (let d of o) t.push(d);
  }
  return t;
}
var j = 0,
  y = class s {
    hapticLabel = null;
    domInitialized = !1;
    instanceId;
    debug;
    showSwitch;
    rafId = null;
    patternResolve = null;
    audioCtx = null;
    audioFilter = null;
    audioGain = null;
    audioBuffer = null;
    constructor(i) {
      ((this.instanceId = ++j), (this.debug = i?.debug ?? !1), (this.showSwitch = i?.showSwitch ?? !1));
    }
    static isSupported = typeof navigator < 'u' && typeof navigator.vibrate == 'function';
    async trigger(i = [{ duration: 25, intensity: 0.7 }], t) {
      let e = S(i);
      if (!e) return;
      let { vibrations: n } = e;
      if (n.length === 0) return;
      let r = Math.max(0, Math.min(1, t?.intensity ?? 0.5));
      for (let a of n)
        if ((a.duration > x && (a.duration = x), !Number.isFinite(a.duration) || a.duration < 0 || (a.delay !== void 0 && (!Number.isFinite(a.delay) || a.delay < 0)))) {
          console.warn('[web-haptics] Invalid vibration values. Durations and delays must be finite non-negative numbers.');
          return;
        }
      if ((s.isSupported && navigator.vibrate(H(n, r)), !s.isSupported || this.debug)) {
        if ((this.ensureDOM(), !this.hapticLabel)) return;
        (this.debug && (await this.ensureAudio()), this.stopPattern());
        let o = (n[0]?.delay ?? 0) === 0;
        if (o && (this.hapticLabel.click(), this.debug && this.audioCtx)) {
          let d = Math.max(0, Math.min(1, n[0].intensity ?? r));
          this.playClick(d);
        }
        await this.runPattern(n, r, o);
      }
    }
    cancel() {
      (this.stopPattern(), s.isSupported && navigator.vibrate(0));
    }
    destroy() {
      (this.stopPattern(),
        this.hapticLabel && (this.hapticLabel.remove(), (this.hapticLabel = null), (this.domInitialized = !1)),
        this.audioCtx && (this.audioCtx.close(), (this.audioCtx = null), (this.audioFilter = null), (this.audioGain = null), (this.audioBuffer = null)));
    }
    setDebug(i) {
      ((this.debug = i), !i && this.audioCtx && (this.audioCtx.close(), (this.audioCtx = null), (this.audioFilter = null), (this.audioGain = null), (this.audioBuffer = null)));
    }
    setShowSwitch(i) {
      if (((this.showSwitch = i), this.hapticLabel)) {
        let t = this.hapticLabel.querySelector('input');
        ((this.hapticLabel.style.display = i ? '' : 'none'), t && (t.style.display = i ? '' : 'none'));
      }
    }
    stopPattern() {
      (this.rafId !== null && (cancelAnimationFrame(this.rafId), (this.rafId = null)), this.patternResolve?.(), (this.patternResolve = null));
    }
    runPattern(i, t, e) {
      return new Promise((n) => {
        this.patternResolve = n;
        let r = [],
          a = 0;
        for (let l of i) {
          let c = Math.max(0, Math.min(1, l.intensity ?? t)),
            u = l.delay ?? 0;
          (u > 0 && ((a += u), r.push({ end: a, isOn: !1, intensity: 0 })), (a += l.duration), r.push({ end: a, isOn: !0, intensity: c }));
        }
        let o = a,
          d = 0,
          p = -1,
          v = (l) => {
            d === 0 && (d = l);
            let c = l - d;
            if (c >= o) {
              ((this.rafId = null), (this.patternResolve = null), n());
              return;
            }
            let u = r[0];
            for (let h of r)
              if (c < h.end) {
                u = h;
                break;
              }
            if (u.isOn) {
              let h = L + (1 - u.intensity) * A;
              p === -1
                ? ((p = l), e || (this.hapticLabel?.click(), this.debug && this.audioCtx && this.playClick(u.intensity), (e = !0)))
                : l - p >= h && (this.hapticLabel?.click(), this.debug && this.audioCtx && this.playClick(u.intensity), (p = l));
            }
            this.rafId = requestAnimationFrame(v);
          };
        this.rafId = requestAnimationFrame(v);
      });
    }
    playClick(i) {
      if (!this.audioCtx || !this.audioFilter || !this.audioGain || !this.audioBuffer) return;
      let t = this.audioBuffer.getChannelData(0);
      for (let a = 0; a < t.length; a++) t[a] = (Math.random() * 2 - 1) * Math.exp(-a / 25);
      this.audioGain.gain.value = 0.5 * i;
      let e = 2e3 + i * 2e3,
        n = 1 + (Math.random() - 0.5) * 0.3;
      this.audioFilter.frequency.value = e * n;
      let r = this.audioCtx.createBufferSource();
      ((r.buffer = this.audioBuffer), r.connect(this.audioFilter), (r.onended = () => r.disconnect()), r.start());
    }
    async ensureAudio() {
      if (!this.audioCtx && typeof AudioContext < 'u') {
        ((this.audioCtx = new AudioContext()),
          (this.audioFilter = this.audioCtx.createBiquadFilter()),
          (this.audioFilter.type = 'bandpass'),
          (this.audioFilter.frequency.value = 4e3),
          (this.audioFilter.Q.value = 8),
          (this.audioGain = this.audioCtx.createGain()),
          this.audioFilter.connect(this.audioGain),
          this.audioGain.connect(this.audioCtx.destination));
        let i = 0.004;
        this.audioBuffer = this.audioCtx.createBuffer(1, this.audioCtx.sampleRate * i, this.audioCtx.sampleRate);
        let t = this.audioBuffer.getChannelData(0);
        for (let e = 0; e < t.length; e++) t[e] = (Math.random() * 2 - 1) * Math.exp(-e / 25);
      }
      this.audioCtx?.state === 'suspended' && (await this.audioCtx.resume());
    }
    ensureDOM() {
      if (this.domInitialized || typeof document > 'u') return;
      let i = `web-haptics-${this.instanceId}`,
        t = document.createElement('label');
      (t.setAttribute('for', i),
        (t.textContent = 'Haptic feedback'),
        (t.style.position = 'fixed'),
        (t.style.bottom = '10px'),
        (t.style.left = '10px'),
        (t.style.padding = '5px 10px'),
        (t.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'),
        (t.style.color = 'white'),
        (t.style.fontFamily = 'sans-serif'),
        (t.style.fontSize = '14px'),
        (t.style.borderRadius = '4px'),
        (t.style.zIndex = '9999'),
        (t.style.userSelect = 'none'),
        (this.hapticLabel = t));
      let e = document.createElement('input');
      ((e.type = 'checkbox'),
        e.setAttribute('switch', ''),
        (e.id = i),
        (e.style.all = 'initial'),
        (e.style.appearance = 'auto'),
        this.showSwitch || ((t.style.display = 'none'), (e.style.display = 'none')),
        t.appendChild(e),
        document.body.appendChild(t),
        (this.domInitialized = !0));
    }
  };
window.WebHaptics = y;
window.defaultHapticPatterns = f;
